<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M12.5 2.00012C18.299 2.00012 23 6.70113 23 12.5001C23 18.2991 18.299 23.0001 12.5 23.0001C6.70101 23.0001 2 18.2991 2 12.5001C2 6.70113 6.70101 2.00012 12.5 2.00012ZM11.501 14.6964L7.41699 11.6115L6.81348 12.4093L6.21191 13.2072L11.8965 17.5031L12.5 17.9581L13.1025 17.5031L18.7881 13.2072L17.583 11.6115L13.501 14.6954L13.5 7.672H12.5L11.5 7.67102L11.501 14.6964Z"
      fill="currentColor"
    />
  </svg>
</template>
